import VehicleForm from './components/VehicleForm';
import AccountMasterForm from './components/AccountMasterForm';
import StationMasterForm from './components/StationMasterForm';
import ItemMasterForm from './components/ItemMasterForm';

export function selectForm(formType) {
    if (formType === 'vehicle') {
        return VehicleForm;
    } else if (formType === 'account') {
        return AccountMasterForm;
    } else if (formType === 'station') {
        return StationMasterForm;
    } else if (formType === 'item') {
        return ItemMasterForm;
    } else {
        throw new Error('Invalid form type');
    }
}

// Example usage
const form = selectForm('vehicle'); // This will return VehicleForm